import request from '@/utils/request'

export function  guangao(data) {//banner图
  return request({
    url: `/banner/home`,
    method: 'get',
	
  })
}
export function lunbos(data) {//banner图
  return request({  
	  url:'/banner/list',
	  method: 'post',
	  data:data
  })
}
export function fenleilunbo(data) {//banner图
  return request({  
	  url:`/banner/${data.type}`,
	  method:'get',
	  // data:data
  })
}
export function  forum(data) {
  return request({
    url: '/invitation/home/forum',
    method: 'get',
  })
}
export function  resource(data) {
  return request({
    url: '/resource/home/resource',
    method: 'get',
  })
}
export function  yinsizhence(data) {//隐私政策
  return request({
    url: '/company/privateAgreement',
    method: 'get',
  })
}
export function  yonghuxieyi(data) {//用户协议
  return request({
    url: '/company/userAgreement',
    method: 'get',
  })
}

export function  qiyexinxi(data) {//企业信息
  return request({
    url: '/company/synopsis',
    method: 'get',
  })
}
export function  jifenduiguize(data) {//积分兑换规则
  return request({
    url: '/company/coinAgreement',
    method: 'get',
  })
}
export function  dibudaohan(data) {//查询导航栏
  return request({
    url: '/company/tabbar',
    method: 'get',
  })
}
